import { AfterViewInit, Component, EventEmitter, HostListener, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChange, SimpleChanges, TemplateRef, ViewChild, ViewEncapsulation } from '@angular/core';
import { FilterService, PageService, PageSettingsModel, SortService, ToolbarService } from '@syncfusion/ej2-angular-treegrid';
import { customFilterListModel, CustomGridButton, CustomGridColor, CustomGridFiltering, CustomGridImg, CustomgridOptions, CustomGridSorting, GridColConfig, RowCountResponse } from '../custom-grid/custom-grid';
import * as _ from 'lodash';
import { filter } from 'lodash';
import { Subject, Subscription, takeUntil } from 'rxjs';
import { CustomGridSService } from '../custom-grid/custom-grid-s.service';
import { TreeGridComponent } from '@syncfusion/ej2-angular-treegrid';
import { trigger, transition, style, animate } from '@angular/animations';



@Component({
  selector: 'app-custom-treegrid',
  templateUrl: './custom-treegrid.component.html',
  styleUrls: ['./custom-treegrid.component.scss'],
  animations: [
    trigger('onOff', [
      transition(':enter', [
        style({ transform: 'translateY(-100%)', opacity: 0 }),
        animate('150ms', style({ transform: 'translateY(0)', opacity: 1, }))
      ]),
      transition(':leave', [
        style({ transform: 'translateY(0)', opacity: 1 }),
        animate('150ms', style({ transform: 'translateY(-100%)', opacity: 0 }))
      ])
    ])
  ],
  encapsulation: ViewEncapsulation.Emulated,
})
export class CustomTreeGridComponent implements OnInit, AfterViewInit, OnChanges, OnDestroy {

  @ViewChild('Ctablel') tableEl: TreeGridComponent | undefined;
  @Input() dataSource: Array<any> = new Array<any>;
  @Input() gridColConfig!: Array<GridColConfig>;
  @Input() pageSettings: PageSettingsModel | undefined;
  @Input() paging: boolean | undefined;
  @Input() template: TemplateRef<any> | undefined;
  @Input() tableOptions: CustomgridOptions | undefined;
  @Input() widthT: string | undefined;
  @Input() heightT: string | undefined;

  // outputs
  @Output() onActionBegin: EventEmitter<any> = new EventEmitter<any>();
  @Output() onRowDataBound: EventEmitter<any> = new EventEmitter<any>();
  @Output() onSwitchChange: EventEmitter<any> = new EventEmitter<any>();
  @Output() onDropdownChange: EventEmitter<any> = new EventEmitter<any>();
  @Output() onCheckBoxChange: EventEmitter<any> = new EventEmitter<any>();
  @Output() onButtonClick: EventEmitter<any> = new EventEmitter<any>();
  @Output() onDataSourceChange: EventEmitter<any> = new EventEmitter<any>();
  @Output() onActionComplete: EventEmitter<any> = new EventEmitter<any>();
  @Output() onExpanding: EventEmitter<any> = new EventEmitter<any>();

  parsedData: Array<any> | undefined;
  parsedOption: CustomgridOptions | undefined;
  parsedPageOptions: PageSettingsModel | undefined;
  totalRows: number = 0;
  parsedSwitchData: any;
  lastSession: boolean = false;

  // subscription for http call
  private theEnd$ = new Subject<void>();


  pageSettingsDefault: PageSettingsModel = {
    pageSize: 50,
    pageSizes: [50, 100, 200],
    pageCount: 1,
    currentPage: 1,
    totalRecordsCount: 50,
  }
  getScreenWidth: number = 0;
  getScreenHeight: number = 0;
  rowMode: string = '';

  // ordinamento tabella
  sortTaable: CustomGridSorting[] = [];

  showFilter: boolean = false;

  // filtri tabella
  filterTable: customFilterListModel[] = [];

  regioni: Array<any> = [];

  province: Array<any> = [];

  comuni: Array<any> = [];

  constructor(
    private customGridService: CustomGridSService,
  ) {

    if (this.widthT == undefined) {
      this.widthT = 'auto';
    }

    if (this.heightT == undefined) {
      this.heightT = 'auto';
    }

    if (this.pageSettings == undefined) {
      //this.pageSettings = this.pageSettingsDefault;
      this.parsePage(this.pageSettingsDefault);
    }

    if (this.paging == undefined) {
      this.paging = true;
    }

    if (this.dataSource == null) {
      this.dataSource = [];
    }

  }

  @HostListener('window:resize', ['$event'])
  onWindowResize() {
    this.getScreenWidth = window.innerWidth;
    this.getScreenHeight = window.innerHeight;
    if (this.getScreenHeight > this.getScreenWidth) {
      this.rowMode = "Vertical"
    } else {
      this.rowMode = "Orizzontal"
    }
  }

  created(args: any): void {

    console.log("KEYPRESSSED");
    if (this.tableEl) {
      this.tableEl.search(args.target.value)
      if (args.target.value.length > 0) {
        this.tableEl.expandAll();
      } else {
        this.tableEl.collapseAll();
      }

    }
  }

  showFilters(event: any) {
    this.showFilter = !this.showFilter;
    console.log(this.tableEl)
  }

  ngOnDestroy(): void {
    //this.dataSource = [];
    //this.theEnd$.unsubscribe();
    // unsubscribe observable and subscriptions
    this.theEnd$.unsubscribe();
  }


  ngOnInit(): void {
    console.log('TTGG')
    console.log(this.pageSettings)
    this.onWindowResize();
  }

  ngAfterViewInit(): void {
    let o = this.pageSettings!.currentPage || 1;
    let ps = this.pageSettings!.pageSize || 25;
    let ofs = (o - 1) * (ps);
    this.getDataLazy(ofs, ps, 1);

    /*this.customGridService.getLazyData(this.tableOptions!.apiCallurl,ofs,ps).subscribe({
      next: (data: Array<any>) => {
        if(this.tableEl != undefined){
          this.tableEl!.dataSource = data;
        }
        this.dataSource = data;
      },
      error: () => {

      },
      complete: () => {

      }
    });*/

    //this.tableEl!.refresh();
    //setTimeout(() => {
    this.tableEl!.pageSettings = this.pageSettings || this.pageSettingsDefault;
    this.parsePage(this.pageSettings || this.pageSettingsDefault);
    if (this.pageSettings != undefined || this.pageSettings != null) {
      this.pageSettingsDefault = this.pageSettings;
    }
    //}, 0);

    console.warn("\n Tabella aggiornata! \n");
    console.log(this.tableEl?.pageSettings);
  }

  expanding(event: any) {
    console.warn("EXPANDING :)")
    console.log(event.data.taskData)
    this.onExpanding.emit(event);




    if (event.data.taskData.dataType == "regione") {
      this.regioni.forEach(r => {
        r.expanded = false;
      })

      this.province.forEach(r => {
        r.expanded = false;
      })

      this.regioni.find(x => x.rowId == event.data.taskData.rowId).expanded = true;
    }

    if (event.data.taskData.dataType == "provincia") {
      this.province.forEach(r => {
        r.expanded = false;
      })
      this.province.find(x => x.rowId == event.data.taskData.rowId).expanded = true;
    }

    this.getDataLazyWithArg(0, 0, 1, [], [], event.data.taskData.dataType, event.data.taskData.rowId);

  }

  ngOnChanges(changes: { options: SimpleChange, dataSource: SimpleChange, pageSettings: SimpleChange, tableOptions: SimpleChange, filterTable: SimpleChange }): void {
    console.warn(" \n \n \n changes detected");
    console.log(changes);
    /*if (changes.options) {
      let o = this.pageSettings!.currentPage || 1;
      let ps = this.pageSettings!.pageSize || 25;
      let ofs = (o - 1) * (ps);
      this.getDataLazy(ofs, ps, 1);
      this.refreshTable()
    }
    /*if(changes.dataSource) {
      console.log("\n \n \n Data source changed ?");
      if(this.tableEl != undefined) {
        this.tableEl.dataSource = changes.dataSource.currentValue;
        this.tableEl.refresh();
        console.log("\n yes it changed");
      }
      this.tableEl!.dataSource = changes.dataSource.currentValue;
      this.onDataSourceChange.emit(changes.dataSource.currentValue);
    }*/

    /*
        if (changes.pageSettings) {
          if (this.tableEl != undefined) {
            //this.tableEl!.pageSettings = this.pageSettings || this.pageSettingsDefault;
            this.parsePage(changes.pageSettings.currentValue);
          }
        }
    
    
    
    
        if (changes.tableOptions) {
          this.parseOptions(changes.tableOptions.currentValue);
          let o = this.pageSettings!.currentPage || 1;
          let ps = this.pageSettings!.pageSize || 25;
          let ofs = (o - 1) * (ps);
          this.getDataLazy(ofs, ps, 1);
    
          if (this.tableEl != null || this.tableEl != undefined) {
            this.tableEl!.pageSettings = this.pageSettings || this.pageSettingsDefault;
          }
    
    
          this.parsePage(this.pageSettings || this.pageSettingsDefault);
          if (this.pageSettings != undefined || this.pageSettings != null) {
            this.pageSettingsDefault = this.pageSettings;
          }
        }
    
        this.tableEl?.refresh()*/
  }

  getImagePath(data: GridColConfig): string {
    return (data.fieldOptions as CustomGridImg).path;
  }

  // button
  getButtuonIcon(data: GridColConfig): string | undefined {
    return (data.fieldOptions as CustomGridButton)?.icon || undefined;
  }

  getButtonLabel(data: GridColConfig): string | undefined {
    return (data.fieldOptions as CustomGridButton)?.label || undefined;
  }

  getButtonAlign(data: GridColConfig): string | undefined {
    return (data.fieldOptions as CustomGridButton)?.align || undefined;
  }

  // color
  getColorHeight(data: GridColConfig): string {
    return (data.fieldOptions as CustomGridColor).height;
  }

  getColorWidth(data: GridColConfig): string {
    return (data.fieldOptions as CustomGridColor).width;
  }

  parseOptions(options: CustomgridOptions) {
    this.parsedOption = _.cloneDeep(options);
    if (this.tableEl != undefined) {
      this.tableEl.refresh();
    }
  }

  parseData(data: Array<any>) {
    this.parsedData = _.cloneDeep(data)
    console.log(this.parsedData)
    if (this.tableEl != undefined) {
      this.tableEl.dataSource = data;
    }

    // setTimeout(()=>{
    //   if(data==null){
    //     this.parsedData=[];
    //   }
    // },10)


  }

  checkFilters(e: any) {
    console.log(e)
    if (e.columns != undefined) {
      this.filterTable = [];
      e.columns.forEach((c: any) => {
        this.filterTable.push(
          {
            field: c.field,
            filterValue: c.filterValue,
            type: c.type,
            name: c.name,
            dropdownFilterUrl: c.dropdownFilterUrl,
            filterDropdown: c.filterDropdown
          })
      });
      console.log("Dati da inviare");
      console.log(this.filterTable);
    } else {
      this.filterTable = [];
    }

    // imposto variabile per sorting

    // se ci sono ordinamenti aggiungo campi
    if (e.columnName != undefined) {
      this.sortTaable = [];
      this.sortTaable.push(
        {
          field: e.columnName,
          direction: e.direction,
        },
      );
      console.log("Dati sorting");
      console.log(this.sortTaable);
    } else {
      this.sortTaable = [];
    }

    // page data
    let o = this.pageSettings!.currentPage || 1;
    let ps = this.pageSettings!.pageSize || 25;
    let ofs = (o - 1) * (ps);


    if (e.requestType == 'paging') {
      let currentPage = e.currentPage - 1;
      let offset = e.pageSize * currentPage;

      /*console.log("\n ============================== \n sorting");
      //let filters = this.tableEl!.sortSettings.columns || [];
      if(filters.length > 0) {
        filters.forEach(f => {
          sort.push({direction: f.direction || "", field: f.field || ""});
        });
      }*/

      this.getDataLazy(offset, e.pageSize, e.currentPage, this.filterTable, this.sortTaable);
      //this.getDataLazy(ofs,ps,this.pageSettings?.currentPage,filters,sort);
    }
    if (e.requestType == 'filtering') {
      console.log("Doing filter");
      this.getDataLazy(ofs, ps, this.pageSettings?.currentPage, this.filterTable, this.sortTaable);
    }
    if (e.requestType == 'refresh') {
      //better do nothing
    }
    if (e.requestType == 'sorting') {

      /*console.log("\n Filter active in table ");
      console.log(e);

      let o = this.pageSettings!.currentPage || 1;
      let ps = this.pageSettings!.pageSize || 25;
      let ofs = (o-1) * (ps);*/
      this.getDataLazy(ofs, ps, this.pageSettings?.currentPage, this.filterTable, this.sortTaable);

    }

    return;

  }

  onKeyPress(e: any) {
    console.log(e)
  }

  /*******************************************************************************************  azioni lazy loading **************************************************/
  emitActionBegin(e: any) {
    console.log(e);
    this.onActionBegin.emit(e);
    if (this.lastSession) {
      return;
    }

    // preparo i filtri
    console.log(e.columns);
    // filtri vuota


    // se ci sono filtri aggiungo campi
    if (e.columns != undefined) {
      this.filterTable = [];
      e.columns.forEach((c: any) => {
        this.filterTable.push(
          {
            field: c.field,
            filterValue: c.filterValue,
            type: c.type,
            name: c.name,
            dropdownFilterUrl: c.dropdownFilterUrl,
            filterDropdown: c.filterDropdown
          })
      });
      console.log("Dati da inviare");
      console.log(this.filterTable);
    } else {
      this.filterTable = [];
    }

    // imposto variabile per sorting

    // se ci sono ordinamenti aggiungo campi
    if (e.columnName != undefined) {
      this.sortTaable = [];
      this.sortTaable.push(
        {
          field: e.columnName,
          direction: e.direction,
        },
      );
      console.log("Dati sorting");
      console.log(this.sortTaable);
    } else {
      this.sortTaable = [];
    }

    // page data
    let o = this.pageSettings!.currentPage || 1;
    let ps = this.pageSettings!.pageSize || 25;
    let ofs = (o - 1) * (ps);


    if (e.requestType == 'paging') {
      let currentPage = e.currentPage - 1;
      let offset = e.pageSize * currentPage;

      /*console.log("\n ============================== \n sorting");
      //let filters = this.tableEl!.sortSettings.columns || [];
      if(filters.length > 0) {
        filters.forEach(f => {
          sort.push({direction: f.direction || "", field: f.field || ""});
        });
      }*/

      this.getDataLazy(offset, e.pageSize, e.currentPage, this.filterTable, this.sortTaable);
      //this.getDataLazy(ofs,ps,this.pageSettings?.currentPage,filters,sort);
    }

    if (e.requestType == 'refresh') {
      //better do nothing
      return;
    }
    if (e.requestType == 'sorting') {

      /*console.log("\n Filter active in table ");
      console.log(e);

      let o = this.pageSettings!.currentPage || 1;
      let ps = this.pageSettings!.pageSize || 25;
      let ofs = (o-1) * (ps);*/
      this.getDataLazy(ofs, ps, this.pageSettings?.currentPage, this.filterTable, this.sortTaable);

    }

    return;
  }




  switchChange(event: any, data: any) {
    let d: object = {
      event: event,
      data: data,
    }
    this.onSwitchChange.emit(d);
  }


  dropdownChange(event: any, data: any) {
    let d: object = {
      event: event,
      data: data,
    }
    this.onDropdownChange.emit(d);
  }

  checkBoxChange(event: any, data: any) {
    let d: Object = {
      event: event,
      data: data,
    };
    this.onCheckBoxChange.emit(d);
  }

  emitActionComplete(event: any) {

    if (event.requestType == 'refresh') {
      //better do nothing
      return;
    }
    console.warn(event)
    //this.onActionComplete.emit(event);
  }

  rowDB(event: any) {
    this.onRowDataBound.emit(event);
  }

  emitBtnClick(data: any, event: any) {
    let d: Object = {
      action: event,
      data: data,
    }
    this.onButtonClick.emit(d);
  }

  parsePage(page: PageSettingsModel) {
    this.parsedPageOptions = _.cloneDeep(page);
    if (this.tableEl != undefined) {
      this.tableEl.pageSettings = page;
    }
  }

  getDataLazy(offset: number, max: number, currentPage?: number, filter?: customFilterListModel[], sort?: CustomGridSorting[]) {

    if (this.tableEl != undefined) {
      this.tableEl!.dataSource = [];
    }

    this.regioni = [];
    this.comuni = [];
    this.province = [];
    this.dataSource = [];

    this.customGridService.getLazyData(this.tableOptions!.apiCallurl, offset, max, filter, sort).pipe(takeUntil(this.theEnd$)).subscribe({
      next: (data: Array<any>) => {
        data.forEach(reg => {
          if (reg.dataType == "regione") {
            this.dataSource.push(reg);
            this.regioni.push(reg);
            console.log(reg)
          } else {
            this.province.push(reg);
            this.dataSource.push(reg);
            console.error(reg)
          }
        })

        this.tableEl!.dataSource = this.dataSource;
        this.onDataSourceChange.emit(data);
        if (this.lastSession) {
          this.parseData(data);
          console.log("FHDSKJFHDSKLGHDSJGN")
          console.error(data)
        }
      },
      error: (e: any) => {
        console.error("Could not get any data!!");
      },
      complete: () => {
        let c = currentPage || 1;
        setTimeout(() => {
          this.countRows(c, max, filter);
          this.tableEl?.collapseAll();
        }, 100);

      }
    });
  }

  getDataLazyWithArg(offset: number, max: number, currentPage?: number, filter?: CustomGridFiltering[], sort?: CustomGridSorting[], arg?: string, parent?: string) {

    this.customGridService.getLazyDataWithArg(this.tableOptions!.apiCallurl, offset, max, filter, sort, arg, parent).pipe(takeUntil(this.theEnd$)).subscribe({
      next: (data: Array<any>) => {


        if (arg == "regione") {

          data.forEach(d => {
            if (!this.province.find(x => x.rowId == d.rowId)) {
              this.province.push(d);
            }
          });

        }

        if (arg == "provincia") {
          data.forEach(d => {
            if (!this.comuni.find(x => x.rowId == d.rowId)) {
              this.comuni.push(d);
            }
          });
        }

        this.dataSource = [];


        this.regioni = this.regioni.filter(x => x.rowId != `fake${parent}`);

        this.regioni.forEach(reg => {
          /*if(reg.rowId != `fake${parent}`){
            console.log(reg)*/
          this.dataSource.push(reg);
          /*}else{
            console.error("DA ELIMINARE")
            console.error(reg)
            //this.province.splice(this.regioni.find(x=>x.rowId == reg.rowId).indexOf,1);
          }*/
        })


        this.province = this.province.filter(x => x.rowId != `fake${parent}`);

        this.province.forEach(reg => {
          /*if(reg.rowId === `fake${parent}`){

            console.error("DA ELIMINARE")
            console.log(`fake${parent}`)
            console.error(reg)
            //this.province.splice(this.province.find(x=>x.rowId == reg.rowId).indexOf,1);

            //continue;
          }else*/

          this.dataSource.push(reg);


        })




        this.comuni.forEach(reg => {

          this.dataSource.push(reg);
        })




        console.error("REGIONI");
        console.warn(this.regioni);

        console.error("PROVINCE");
        console.warn(this.province);

        console.error("COMUNI");
        console.warn(this.comuni);

        // _.remove(this.dataSource,this.dataSource.filter(x=> x.rowId == `fake${parent}`))

        // _.remove(this.regioni,this.regioni.filter(x=> x.rowId == `fake${parent}`))

        // _.remove(this.province,this.province.filter(x=> x.rowId == `fake${parent}`))

        //this.dataSource.push(this.regioni)

        //this.tableEl!.dataSource = this.dataSource;
        //this.onDataSourceChange.emit(data);

      },
      error: (e: any) => {
        console.error("Could not get any data!!");
      },
      complete: () => {
        setTimeout(() => {
          this.tableEl!.dataSource = this.dataSource;
          console.error("DATASOURCE");
          console.warn(this.tableEl?.dataSource);
        }, 100);

      }
    });
  }

  countRows(currentPage: number, pageS: number, filters?:customFilterListModel[]) {
    /*this.customGridService.countRows(this.tableOptions!.rowsCallurl, this.tableOptions!.apiTableName, filters).pipe(takeUntil(this.theEnd$)).subscribe({
      next: (rows: any) => {
        console.log(rows);
        this.pageSettingsDefault!.totalRecordsCount = rows;
        let pages = rows / pageS;
        this.pageSettingsDefault!.pageCount = Math.ceil(pages);
        this.totalRows = rows;
        this.pageSettingsDefault!.currentPage = currentPage;
        this.pageSettingsDefault!.pageSize = pageS;


        console.warn(this.pageSettingsDefault);

        //console.warn(this.tableEl!.pageSettings);
        if (this.tableEl != null || this.tableEl != undefined) {
          if (this.pageSettings!.totalRecordsCount != undefined && this.pageSettings!.totalRecordsCount > 0) {
            this.tableEl!.pageSettings = this.pageSettingsDefault;
          }

        }

        this.lastSession = false;
      },
      error: (e: any) => {
        console.error("Impossibile ottenere i dati");
      },
    });*/

  }

  /**
   * Push data in to the grid
   */
  refreshTable() {
    /*this.tableEl!.addRecord(e);
    this.tableEl!.refresh();*/


    let o = this.pageSettings!.currentPage || 1;
    let ps = this.pageSettings!.pageSize || 25;
    let ofs = (o - 1) * (ps);
    this.getDataLazy(ofs, ps, 1);
  }

}
